import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  toggle() {
    const showing = this.inputTarget.type === "password"
    this.inputTarget.type = showing ? "text" : "password"
    this.showIconTarget.classList.toggle("hidden", showing)
    this.hideIconTarget.classList.toggle("hidden", !showing)
  }
}
